<template>
  <!-- 产融供应链 -->
  <div>
    <!-- 顶部背景图 -->
    <div class="crSupplyChain-top"></div>
    <!-- 核心业务场景 -->
    <div class="HxYwcJ">
      <p class="Title">核心业务场景</p>
      <div class="div">
        <div class="div0 div1"></div>
        <div class="div0 div2">
          <el-tabs :tab-position="tabPosition" style="width: 100%; height: 100%">
            <el-tab-pane label="供应链服务">
              <div class="ywcj-one"></div>
            </el-tab-pane>
            <el-tab-pane label="物流规划">
              <div class="ywcj-two">
                <div class="diva">
                  <div class="diva-a"></div>
                  <div class="diva-b">
                    <img src="../../assets/crSupplyChain/ywcj-gyljr_zxxc.png" alt="" />
                    <p>在线选仓</p>
                  </div>
                  <div class="diva-b">
                    <img src="../../assets/crSupplyChain/ywcj-gyljr_cpyt.png" alt="" />
                    <p>仓配一体</p>
                  </div>
                  <div class="diva-b">
                    <img src="../../assets/crSupplyChain/ywcj-gyljr_gsly.png" alt="" />
                    <p>公水联运</p>
                  </div>
                  <div class="diva-b">
                    <img src="../../assets/crSupplyChain/ywcj-gyljr_ysgh.png" alt="" />
                    <p>运输路由规划</p>
                  </div>
                  <div class="diva-a"></div>
                </div>
                <div class="divb">
                  <div class="divb-a">
                    提供在线选仓、仓配一体、公水联运、运输路由规划，解决客户对仓库规划不合理和运输路径长的问题，提高效率节省成本。
                  </div>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="供应链金融">
              <div class="ywcj-three">
                <div class="diva"></div>
                <div class="divb">
                  提供代采垫资、集采垫资、商业保理、仓单质押、运费融资等多项供应链金融服务，和ABS、供应链票据、标准化票据等创新金融服务，解决中小微企业对资金的需求，助力中小微企业发展。
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="行业解决方案">
              <div class="ywcj-four">
                <div class="diva">
                  <div class="diva-a"></div>
                  <div class="diva-b">
                    <img src="../../assets/crSupplyChain/ywcj-jjfa_cylyh.png" alt="" />
                    <p>产业链优化</p>
                    <p class="p-two">原料、加工、采购、贸易资源整合共享</p>
                  </div>
                  <div class="diva-b">
                    <img src="../../assets/crSupplyChain/ywcj-jjfa_zhjjfa.png" alt="" />
                    <p>综合解决方案</p>
                    <p class="p-two">系统、咨询、代运营、新兴技术应用</p>
                  </div>
                  <div class="diva-b">
                    <img src="../../assets/crSupplyChain/ywcj-jjfa_gylsj.png" alt="" />
                    <p>供应链升级</p>
                    <p class="p-two">品牌、渠道、工厂、仓库、 运输、配送协同</p>
                  </div>
                  <div class="diva-a"></div>
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
        <div class="div0 div6"></div>
      </div>
    </div>
    <!-- 服务优势 -->
    <div class="ServiceYous">
      <p class="Title">服务优势</p>
      <div class="div">
        <div class="div0"></div>
        <div class="div1">
          <div class="div1-1">
            <img src="../../assets/crSupplyChain/fwys-cgyt.png" alt="" />
            <p>丰富的采购业态</p>
          </div>
          <div class="div1-2">
            <div>
              支持客户个性化需求，流程可配置、页面可定制，支持不同用户不同服务解决方案，支持多种采购执行模式
            </div>
          </div>
        </div>
        <div class="div1">
          <div class="div1-1">
            <img src="../../assets/crSupplyChain/fwys-yzgys.png" alt="" />
            <p>共享平台优质供应商</p>
          </div>
          <div class="div1-2">
            <div>共享平台多年积累的优质供应商， 不用辛辛苦苦寻源</div>
          </div>
        </div>
        <div class="div1">
          <div class="div1-1">
            <img src="../../assets/crSupplyChain/fwys-yhjg.png" alt="" />
            <p>共享平台优惠价格</p>
          </div>
          <div class="div1-2" style="text-align: center">
            <div>共享平台集中规模采购优势价格</div>
          </div>
        </div>
        <div class="div1">
          <div class="div1-1">
            <img src="../../assets/crSupplyChain/fwys-fxgl.png" alt="" />
            <p>全面的风险管理</p>
          </div>
          <div class="div1-2">
            <div>充分使用平台风控大数据构建的风险识别模型，保证采购风险可控加强了对供应体系的管理与控制</div>
          </div>
        </div>
        <div class="div0"></div>
      </div>
    </div>
    <!-- 服务态度 -->
    <div class="ServiceTaid">
      <p class="Title">服务态度</p>
      <div class="div">
        <div class="div0"></div>
        <div class="div1">
          <img src="../../assets/crSupplyChain/fwtd-one.png" alt="" />
          <div class="div1-1">
            <img src="../../assets/crSupplyChain/fwtd-ywlxjms.png" alt="" />
          </div>
          <div class="div1-2">
            <p>丰富的业务类型及模式</p>
            <div>
              平台涵盖了供应链5大业务类型、多种业务模式， 完全供应链日常业务需求。
            </div>
          </div>
        </div>
        <div class="div1">
          <img src="../../assets/crSupplyChain/fwtd-two.png" alt="" />
          <div class="div1-1">
            <img src="../../assets/crSupplyChain/fwtd-bjhxz.png" alt="" />
          </div>
          <div class="div1-2">
            <p>便捷化协作</p>
            <div>平台帮助客户将供应管理延伸到供应链服务，提高了采购、计划、物流、结算、财务等业务流程的协作效率实现了整个供应链的一体化管理，加强了对供应体系的管理与控制。</div>
          </div>
        </div>
        <div class="div0"></div>
      </div>
      <div class="div" style="margin-top: 50px;">
        <div class="div0"></div>
        <div class="div1">
          <img src="../../assets/crSupplyChain/fwtd-three.png" alt="" />
          <div class="div1-1">
            <img src="../../assets/crSupplyChain/fwtd-saasfwms.png" alt="" />
          </div>
          <div class="div1-2">
            <p>SAAS服务模式</p>
            <div>
              以SaaS服务的模式，为客户提供供应链协同服务； 将客户从项目实施风险、系统升级风险、系统运维风险中解脱出来。
            </div>
          </div>
        </div>
        <div class="div1">
          <img src="../../assets/crSupplyChain/fwtd-four.png" alt="" />
          <div class="div1-1">
            <img src="../../assets/crSupplyChain/fwtd-xxksh.png" alt="" />
          </div>
          <div class="div1-2">
            <p>信息可视化</p>
            <div>帮助客户打通的商流、物流、信息流、资金流， 实现信息可视化数字化，为客户决策提供精准数据支持。</div>
          </div>
        </div>
        <div class="div0"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tabPosition: "left",
    };
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
/* 顶部背景图开始 */
.crSupplyChain-top {
  background: url("../../assets/crSupplyChain/crgyl-banner.png") center center no-repeat;
  height: 665px;
}
/* 顶部背景图结束 */
/* 核心业务场景开始 */
.HxYwcJ {
  height: 717px;
  background: #f5f7fa;
}
.HxYwcJ > .Title {
  font-size: 35px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
  text-align: center;
  padding: 70px 0 20px 0;
}
.HxYwcJ > .div {
  display: flex;
}

.HxYwcJ > .div .div1,
.HxYwcJ > .div .div6 {
  flex: 1;
  margin: 0 17px;
}
.HxYwcJ > .div .div2 {
  margin: 30px 22px 0 22px;
  width: 1200px;
  height: 471px;
}
/deep/.el-tab-pane {
  height: 470px;
  display: flex;
}
.HxYwcJ .ywcj-one {
  margin: auto;
  width: 904px;
  height: 384px;
  background: url("../../assets/crSupplyChain/ywcj-gylfw.png") center center no-repeat;
}
.HxYwcJ .ywcj-two,
.HxYwcJ .ywcj-three,
.HxYwcJ .ywcj-four {
  margin: auto;
}
.HxYwcJ .ywcj-two .diva,
.HxYwcJ .ywcj-four .diva {
  display: flex;
}
.HxYwcJ .ywcj-two .diva .diva-a,
.HxYwcJ .ywcj-four .diva .diva-a {
  flex: 1;
}
.HxYwcJ .ywcj-two .diva .diva-b {
  margin: 30px 30px;
  width: 140px;
}
.HxYwcJ .ywcj-two .diva .diva-b img {
  width: 134px;
  height: 154px;
}
.HxYwcJ .ywcj-two .diva .diva-b p,
.HxYwcJ .ywcj-four .diva .diva-b p {
  margin-top: 10px;
  font-size: 23px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #373d41;
  line-height: 45px;
}
.HxYwcJ .ywcj-two .divb,
.HxYwcJ .ywcj-three .divb {
  margin-top: 30px;
  text-align: left;
  padding: 20px 50px;
  background: #e9f6fe;
  border-radius: 8px;
  font-size: 16px;
  line-height: 28px;
}
.HxYwcJ .ywcj-three .diva {
  margin: auto;
  width: 783px;
  height: 259px;
  background: url("../../assets/crSupplyChain/ywcj-gyljr.png") center center no-repeat;
}
.HxYwcJ .ywcj-four .diva .diva-b {
  margin: 30px 50px;
  width: 168px;
}
.HxYwcJ .ywcj-four .diva .diva-b img {
  width: 166px;
  height: 166px;
}
.HxYwcJ .ywcj-four .diva .diva-b .p-two {
  font-size: 15px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
  line-height: 24px;
  margin-top: 20px;
}
/deep/.el-tabs--left .el-tabs__item.is-left {
  text-align: center;
}
/deep/.el-tabs__item.is-active {
  color: #ffffff;
  background: #2f82ff;
}

/deep/.el-tabs__item {
  height: 60px;
  line-height: 60px;
}
/deep/.el-tabs--left .el-tabs__item.is-left {
  width: 254px;
}
/deep/.el-tabs--left .el-tabs__item.is-left:hover {
  color: #ffffff;
  background: #2f82ff;
}
/deep/.el-tabs--left .el-tabs__nav-wrap.is-left {
  background: #ffffff;
  margin-right: 20px;
}

/deep/.el-tabs--left .el-tabs__nav-wrap.is-left::after {
  height: 100%;
  width: 0px;
  bottom: auto;
  top: 0;
}
/deep/.el-tabs__content {
  height: 470px;
  background: #ffffff;
}

/* 核心业务场景结束 */
/* 服务优势开始 */
.ServiceYous {
  height: 589px;
  color: #333333;
  background: #ffffff;
}
.ServiceYous > .Title {
  font-size: 35px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
  text-align: center;
  padding: 70px 0 50px 0;
}
.ServiceYous > .div {
  display: flex;
  padding: 0 5%;
  justify-content: space-between;
}

.ServiceYous > .div .div0 {
  flex: 1;
  padding: 0 20px;
}
.ServiceYous > .div .div1 {
  padding: 0 20px;
  padding-top: 40px;
  width: 248px;
  height: 305px;
  margin: 0 20px;
  background: #ffffff;
  box-shadow: 0px 1px 17px 1px rgba(93, 93, 93, 0.13);
  border-radius: 15px;
}
.ServiceYous > .div .div1 .div1-1 {
  text-align: center;
  font-size: 24px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #373d41;
  line-height: 45px;
  margin-bottom: 20px;
}

.ServiceYous > .div .div1 .div1-1 img {
  width: 48px;
  height: 48px;
  vertical-align: middle;
  margin-bottom: 16px;
}
.ServiceYous > .div .div1 .div1-2 {
  text-align: left;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
  line-height: 29px;
}
/* 服务优势结束 */
/* 服务态度开始 */
.ServiceTaid {
  height: 760px;
  color: #333333;
  background: #f5f7fa;
}
.ServiceTaid > .Title {
  font-size: 35px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
  text-align: center;
  padding: 70px 0 50px 0;
}
.ServiceTaid > .div {
  display: flex;
  padding: 0 5%;
  justify-content: space-between;
}

.ServiceTaid > .div .div0 {
  flex: 1;
  padding: 0 20px;
}
.ServiceTaid > .div .div1 {
  padding: 0 30px;
  width: 550px;
  height: 235px;
  margin: 0 30px;
  background: #ffffff;
  display: flex;
  position: relative;
}
.ServiceTaid > .div .div1 > img {
  width: 32px;
  height: 42px;
  position: absolute;
  left: 16px;
  top: 0px;
}
.ServiceTaid > .div .div1 .div1-1 {
  line-height: 234px;
}

.ServiceTaid > .div .div1 .div1-1 img {
  width: 130px;
  height: 130px;
  vertical-align: middle;
  margin-bottom: 16px;
}
.ServiceTaid > .div .div1 .div1-2 {
  padding: 40px 0 0 30px;
  text-align: left;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
  line-height: 29px;
}
.ServiceTaid > .div .div1 .div1-2 p {
  font-size: 24px;
  color: #373d41;
  line-height: 50px;
}
.ServiceTaid > .div .div1 .div1-2 div{
font-size: 16px;
color: #666666;
line-height: 32px;
}
/* 服务态度结束 */
</style>
